<template>
	<section class="flex gap-8">
		<SessionContentMobileTabButton
			:active="$sessionLayout.mobileTab === 'media'"
			tabName="media"
			@click="$sessionLayout.mobileTab = 'media'"
		>
			Media
		</SessionContentMobileTabButton>
		<SessionContentMobileTabButton
			:active="$sessionLayout.mobileTab === 'devTools'"
			tabName="dev-tools"
			@click="$sessionLayout.mobileTab = 'devTools'"
		>
			Dev Tools
		</SessionContentMobileTabButton>
		<SessionContentMobileTabButton
			:active="$sessionLayout.mobileTab === 'details'"
			tabName="details"
			@click="$sessionLayout.mobileTab = 'details'"
		>
			Details
		</SessionContentMobileTabButton>
	</section>
</template>

<script>
import SessionContentMobileTabButton from 'shared/components/SessionContentMobileTabButton.vue'

export default {
	name: 'SessionContentMobileTabs',
	components: {
		SessionContentMobileTabButton,
	},
}
</script>
